import * as React from 'react';
import {SFC} from 'react';
import {AuthLink as Link} from '../link/link';
import './styles.sass';

export const AuthSignInForgotPassword: SFC<{}> = () => (
  <div className={'auth-sign-in-forgot-password'}>
    <Link purple small url={'/forgot-password'}>
      Forgot password?
    </Link>
  </div>
);
